<template lang="pug">
	.publisher-users
		.page-center-content(v-if="publisher")
			.caption-area
				.back(v-if="Layout.pageOptions.backPage")
					button.btn.btn-sm.btn-ghost-secondary(type="button" @click="Layout.setPage.apply(Layout, Layout.pageOptions.backPage)")
						.icon.fa.fa-angle-double-left
				.caption(:class="{'back-exist': Layout.pageOptions.backPage}") {{publisher.title}} User List
				.go-to-invitations
					button.btn.btn-sm.btn-primary(type="button" @click="Layout.setPage('publisher-invitations', {backPage: ['publisher-users', {}]})") Show invitations
				.logo
					img(:src="`/Images/Icons/Publishers/${publisher.codename || publisher.id}.png?v=${(publisher['last_activity_time'] || publisher['create_date'] || new Date()).getTime()}`" :alt="publisher.title")
			.publishers-table
				DataTable(name="publisher-users" entity="users" :fields="fields" :filters="filters" :buttons="buttons" key-field="id" :sort="['register_date', 'desc']" :update-on="['Layout Page Showed:publisher-users', `Publisher Changed:${publisher.id}`]" :update-if="() => Layout.page === 'publisher-users'" focus-on="Layout Page Showed:publisher-users" :height-offset="Layout.headerHeight + 45")

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import DataTable			from './../../components/Templates/DataTable'

	export default {
		name: "PublisherUsers",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Publisher Data Changed", "Layout Page Showed:publisher-users", "Current User Changed"]
		},
		components: {
			DataTable
		},
		data() {

			this.fields = [
				{
					fieldName: 'id',
					title: 'ID',
					type: 'number',
					display: true,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '70px'
				},
				{
					fieldName: 'photo',
					title: 'Photo',
					type: 'image',
					display: true,
					click: this.openUserProfile,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '50px'
				},
				{
					fieldName: 'name',
					title: 'Name',
					type: 'string',
					display: true,
					click: this.openUserProfile,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '200px'
				},
				{
					fieldName: 'email',
					title: 'Email',
					type: 'string',
					display: true,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '250px'
				},
				{
					fieldName: 'tags',
					title: 'Tags',
					type: 'array',
					display: true,
					displayTransform: tag => ({'admin': 'Admin', 'publisher-admin': 'Company admin', 'invitation': 'Invitation'})[tag] || null,
					displayStyles: tag => ({'Admin': {color: '#20a8d8', fontWeight: 'bold'}, 'Company admin': {color: '#63c2de'}, 'Invitation': {color: '#73818f'}})[tag] || null,
					split: ',',
					sortingAllowed: false,
					filteringAllowed: false,
					width: '50px'
				},
				{
					fieldName: 'register_date',
					title: 'Register',
					type: 'date',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					width: '150px'
				},
				{
					fieldName: 'last_activity_time',
					title: 'Activity',
					type: 'date',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					width: '150px'
				},
				{
					fieldName: 'options',
					title: 'Options',
					type: 'object',
					display: false,
					filteringAllowed: false
				},
				{
					fieldName: 'active',
					title: 'Active',
					type: 'boolean',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					editAllowed: true,
					onChange: this.activateUser,
					width: '90px'
				}
			];

			this.filters = [{
				title: 'Publisher',
				field: 'publisher_id',
				type: 'equal',
				value: 0,
				display: false
			}, {
				title: 'Tag',
				field: 'tags',
				type: 'not:contain:comma',
				value: 'invitation',
				display: false
			}, {
				title: 'Tag',
				field: 'tags',
				type: 'contain:comma',
				value: '',
				options: [{
					title: '',
					value: ''
				}, {
					title: 'Company admin',
					value: 'publisher-admin'
				}],
				display: true
			}];

			this.buttons = [];

			this.publisher = null;

			return {
				showed: true
			}

		},
		methods: {
			collectData() {

				if (Layout.page === 'publisher-users' && Layout.pageOptions?.publisherId) {

					this.publisherId = Layout.pageOptions.publisherId;

				} else if (Publisher.SelectedPublisher) {

					this.publisherId = Publisher.SelectedPublisher.id;

				} else {

					this.publisherId = null;

				}

				this.publisher = Publisher.getPublisher(this.publisherId, Publisher.getSelectedServerId());

				if (this.publisher) this.filters[0].value = this.publisher.id;

				if (User.currentUser && (User.currentUser.Tags['admin'] || User.currentUser.Tags['publisher-admin'])) {

					if (this.buttons.length === 0) {

						this.buttons.push({
							title: 'Add new user',
							position: 'top',
							action: () => {
								Broadcast.call("Show AddUser", [this.publisher]);
							}
						});

					}

				}

			},
			openUserProfile(user) {

				Layout.setPage('user-profile', {userId: user.id, backPage: ['publisher-users', {publisherId: this.publisher.id}]});

			},
			activateUser(user) {

				Server.sendToSocket({
					SetUserStatus: {
						userId: user.id,
						active: user.active
					}
				})

			}
		}
	}
</script>

<style lang="sass" scoped>

	.publisher-users
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1000px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: flex-start
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)

				.back
					display: flex
					align-items: center
					justify-content: center
					padding: 0.2rem 1rem

					button
						width: 30px
						height: 30px

				.caption
					padding: 1rem

				.caption.back-exist
					padding: 1rem 0

				.go-to-invitations
					display: flex
					align-items: center

				.logo
					display: flex
					margin-left: auto
					padding: 10px

					img
						display: flex
						height: 33px
						margin: 0 10px
						align-items: center
						color: #fff
						padding-left: 10px
						text-transform: uppercase

			.publishers-table
				display: flex
				flex-direction: row
				flex-wrap: wrap
				padding: 1rem 0

</style>

